import Client from '@dp/telegram'
import * as Pb from 'google-protobuf'
import { enableLog, getUrlParams, getDomain } from './tools'
import axios from 'axios'

type createParamsType = Parameters<typeof Client.create>[0]
export type Params = createParamsType['params']

type Message = typeof Pb.Message & {
  fromObject: (arg: any) => any
}

export type ExtractFromObjectArg<T> = T extends { fromObject: (arg: infer U) => any } ? U : never

export function getRequest<T extends Message, K extends Message>(Req: T, Res: K) {
  console.log('Req', Req)
  const fullParams = getUrlParams()
  const { aid, code, lan, cvn, svn, svc, cvc, chn, pkg, brd, app, mch, bvs, cnt, token, user_id } =
    fullParams
  const params = {
    auth_token: token || '',
    user_id: user_id ? Number(user_id) : '',
    aid: aid || '',
    code: code || '',
    lan: lan || '',
    cvn: cvn || '',
    svn: svn || '',
    svc: svc || '',
    cvc: cvc || '',
    chn: chn || '',
    pkg: pkg || '',
    app: app || '',
    brd: brd || '',
    mch: mch || '',
    bvs: bvs || '',
    cnt: cnt || '',
  } as any

  const request = Client.create({
    secret: 'B1gYINzAim5cr6UwbA9Q8Q==',
    pSecret: 'sEAN5XglZQtPm/oEawq0ww==',
    params,
    crossDomainOptimization: true,
    adapter: async (options: any) => {
      const { data, params, method, responseType, headers } = options
      const response = await axios({
        method,
        url: options.url,
        data,
        params: {
          code: options.params.code,
          ...params,
        },
        responseType,
        headers,
      })
      return response.data
    },
    parseCommonHeader: (headers = {}) => {
      console.log('headers', headers)
      return {
        ...headers,
        user_id: Number(user_id),
        auth_token: token,
        brand_code: brd,
        timestamp: +new Date(),
      }
    },
  })

  console.log('params', params)
  return (path: string, data: ExtractFromObjectArg<T>) => {
    const url = getDomain()

    if (enableLog()) {
      console.log('request', url + path, data)
    }
    console.log('data', data)
    return request({
      url: `${url}${path}`,
      data,
      Req,
      Res,
    })
  }
}

// function checkUrl(url: string) {
//   if (!url) {
//     throw new Error('url is required')
//   }
//   if (!url.startsWith('http')) {
//     throw new Error('url must start with http')
//   }

//   return url
// }
